import * as React from 'react';
import { IconChevronSmallDown } from '@tocktix/pantry';
import { Select as MuiSelect } from '@material-ui/core';
import { SelectProps as MuiSelectProps } from '@material-ui/core/Select';
import { selectStyles } from './selectCssDefs';

export type SelectProps = MuiSelectProps;

/**
 * @deprecated Deprecated — use pantry Select instead.
 * @see https://docs.tocktix.com/pantry?path=/docs/components-select--docs
 * Migration: Replace Select with the pantry Select component.
 */
export const Select: React.FunctionComponent<React.PropsWithChildren<MuiSelectProps>> = ({
  fullWidth,
  variant = 'outlined',
  labelWidth,
  inputProps,
  name,
  id,
  ...rest
}) => {
  return (
    <MuiSelect
      fullWidth={fullWidth}
      inputProps={{
        style: {
          minWidth: labelWidth,
          width: fullWidth || (labelWidth && labelWidth > 0) ? '100%' : 'auto',
        },
        name,
        id,
        ...inputProps,
      }}
      css={selectStyles}
      native
      IconComponent={IconChevronSmallDown}
      labelWidth={labelWidth}
      variant={variant}
      {...rest}
    ></MuiSelect>
  );
};
